<section class="servicios-carrousel">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="section-title text-center">
          <h2>Servicios adicionales</h2>
          <p><strong>vittal cuenta con servicios exclusivos que podés contratar sin abonar una cuota mensual. Algunos están
            disponibles para cualquier persona, seas o no socio, y otros son exclusivos para quienes ya tienen un
            plan.</strong></p>
          <p>Explorá las opciones disponibles y descubrí cuál se adapta mejor a lo que necesitás hoy.</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="carrousel-wrapper">
          <ngx-slick-carousel 
            class="carousel" 
            [config]="slideConfig">
            <div ngxSlickItem *ngFor="let servicio of servicios" class="servicio-box">
              <div class="servicio-content">
                <img [src]="servicio.imagen" [alt]="servicio.titulo" />
                <h5>{{ servicio.titulo }}</h5>
                <p>{{ servicio.descripcion }}</p>
              </div>
              <div class="ver-mas">
                <a [href]="servicio.link">Ver más</a>
              </div>
            </div>
          </ngx-slick-carousel>
        </div>
      </div>
    </div>
  </div>
</section>